import axios from "axios";
import { get } from "lodash";
import { getFileContentype } from ".";

export const uploadFileByUrl = (uploadUrl, file, callback) => {
  const { contentType } = getFileContentype(get(file, "name", ""), file);
  axios
    .put(uploadUrl, file, {
      headers: {
        "Content-Type": contentType,
      },
    })
    .then(response => {
      console.log("File uploaded successfully", response);
      callback(response);
    })
    .catch(error => {
      console.log("Error", error);
    });
};

export const uploadImage = (uploadUrl, file, callback) => {
  let contentType = "";
  if (file.type === "image/svg+xml") {
    contentType = "image/svg+xml";
  } else {
    contentType = "image/jpeg,image/jpg,image/png,image/gif";
  }
  axios
    .put(uploadUrl, file, {
      headers: {
        "Content-Type": contentType,
      },
    })
    .then(response => {
      console.log("file uploaded successfully");
      callback(response);
    })
    .catch(error => {
      console.log("Error", error);
    });
};

export const uploadVideo = (uploadUrl, file) => {
  let contentType = "";
  if (file.type === "video/mp4") {
    contentType =
      "video/mp4,video/ogg,video/x-ms-wmv,application/x-mpegurl,video/x-msvideo,video/ms-asf,video/x-m4v,video/webm,video/quicktime,video/mpeg,video/3gpp,application/vnd.apple.mpegurl";
  }
  axios
    .put(uploadUrl, file, {
      headers: {
        "Content-Type": contentType,
      },
    })
    .then(() => {
      console.log("file uploaded successfully");
    })
    .catch(error => {
      console.log("Error", error);
    });
};
